import { api } from '../lib/api';
import type { EventRow, WineRow, Participant } from './models';

export interface ArchiveSearchParams {
  sort?: string;
  q?: string;
  year?: string;
  month?: string;
  regionLocation?: string;
  producer?: string;
  varietal?: string;
  personId?: string;
  page?: string;
}

export interface Facets {
  years: number[];
  regionLocations: string[];
  producers: string[];
  varietals: string[];
}

export const archiveApi = {
  search: (params: ArchiveSearchParams) => {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v != null && v !== ''),
    ).toString();
    return api.get<{ items: EventRow[]; total: number; page: number; pageSize: number }>(
      `/archive/events${qs ? `?${qs}` : ''}`,
    );
  },
  get: (id: string) =>
    api.get<{ event: EventRow; wines: WineRow[]; participants: Participant[] }>(
      `/archive/events/${id}`,
    ),
  facets: () => api.get<Facets>('/archive/facets'),
};
